<template>
  <v-card
    :class="['industrial-panel', { 'industrial-panel--flat': flat }]"
    :elevation="elevation"
    rounded="sm"
  >
    <div v-if="title || $slots.title || $slots.actions" class="industrial-panel__header">
      <div class="industrial-panel__header-text">
        <div v-if="overline" class="overline-label">{{ overline }}</div>
        <div v-if="title || $slots.title" class="industrial-panel__title">
          <slot name="title">{{ title }}</slot>
        </div>
        <div v-if="subtitle || $slots.subtitle" class="industrial-panel__subtitle">
          <slot name="subtitle">{{ subtitle }}</slot>
        </div>
      </div>
      <div v-if="$slots.actions" class="industrial-panel__actions">
        <slot name="actions" />
      </div>
    </div>
    <v-card-text v-if="$slots.default" :class="bodyClass">
      <slot />
    </v-card-text>
    <slot v-else />
  </v-card>
</template>

<script>
export default {
  name: 'IndustrialPanel',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    overline: { type: String, default: '' },
    flat: { type: Boolean, default: false },
    elevation: { type: [Number, String], default: 0 },
    bodyClass: { type: String, default: 'pa-4' },
  },
}
</script>

<style scoped>
.industrial-panel {
  background: var(--surface-panel, #fff);
  border: 1px solid var(--border-subtle, #D1D5DB);
  border-radius: var(--radius-panel, 4px) !important;
  box-shadow: var(--panel-shadow, 0 1px 3px rgba(0, 0, 0, 0.06));
}

.industrial-panel--flat {
  box-shadow: none;
}

.industrial-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px 0;
}

.industrial-panel__title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
  line-height: 1.3;
}

.industrial-panel__subtitle {
  font-size: 0.8rem;
  color: var(--text-muted, #6B7280);
  margin-top: 2px;
}

.industrial-panel__actions {
  flex-shrink: 0;
}
</style>
